import styled from '@emotion/styled';
import { FONT } from '../styles/emotion';

export const Text = styled.span<{
  strong?: boolean;
  serif?: boolean;
}>`
  margin: 0;
  padding: 0;
  ${({ strong }) => (strong ? `font-weight: ${FONT.WEIGHT.SEMI_BOLD};` : '')}
  ${({ serif }) => (serif ? `font-family: ${FONT.FAMILY.SERIF};` : '')}
`;
